module.exports = __webpack_public_path__ + "static/media/Rubrik-Logo-1C-Brandmark-Linear-100 (1).1ace66f0.webp";